import { Component } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';
import { MatButtonModule } from '@angular/material/button';

@Component({
  selector: 'app-unsaved-changes-dialog',
  standalone: true,
  imports: [MatButtonModule],
  templateUrl: './unsaved-changes-dialog.component.html',
  styleUrl: './unsaved-changes-dialog.component.css'
})
export class UnsavedChangesDialogComponent {
  constructor(private dialogRef: MatDialogRef<UnsavedChangesDialogComponent>) {}

  onIgnore() {
    this.dialogRef.close('ignore');
  }

  onSave() {
    this.dialogRef.close('save');
  }
}
